import { from, ApolloClient, type NormalizedCacheObject } from '@apollo/client/core/index.js';
import { browser, dev } from '$app/environment';
import { createCache } from '$lib/apollo/cache';
import { errorLink } from '$lib/apollo/error';
import { httpLink } from '$lib/apollo/http';
import { persistedLink } from '$lib/apollo/persisted';
import { session } from '$lib/stores';
import { loggingLink } from './logging';

let browserClient: ApolloClient<NormalizedCacheObject>;
export function getApolloClient() {
  if (browser) {
    if (!browserClient) {
      browserClient = initApolloClient();
    }
    if (window.__APOLLO_CACHE__) {
      browserClient.restore(window.__APOLLO_CACHE__ ? window.__APOLLO_CACHE__ : {});
      window.__APOLLO_CACHE__ = null;
      document.getElementById('apollo-cache')?.remove();
    }
    return browserClient;
  } else {
    let client = session.get()?.apolloClient;
    // In some cases, we skip and resolve early (such as auth proxy routes)
    // so the client won't exist as we aren't in an async hook.
    if (!client) {
      client = initApolloClient();
    }
    return client;
  }
}

export function initApolloClient() {
  const cache = createCache();
  return new ApolloClient({
    name: 'metafy-client',
    version: '3.0',
    cache,
    connectToDevTools: dev,
    queryDeduplication: true,
    link: from([loggingLink(), errorLink(), persistedLink(), httpLink()]),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: browser ? 'cache-first' : 'network-only',
        errorPolicy: 'all'
      },
      query: {
        fetchPolicy: browser ? 'cache-first' : 'network-only',
        errorPolicy: 'all'
      },
      mutate: {
        errorPolicy: 'all'
      }
    }
  });
}
